import { Box, IconButton, InputBase, makeStyles, Theme, createStyles } from "@material-ui/core";
import React, { KeyboardEvent, useEffect, useRef } from "react";
import SearchIcon from "@material-ui/icons/Search";
import CloseIcon from "@material-ui/icons/Close";
import { IProduct } from "pages/home/consumer/service/ProductService";

const useStyles = makeStyles((theme: Theme) => 
  createStyles({
    searchBox: {
      border: `1px solid #E0E1E9`,
      borderRadius: "2px",
      backgroundColor: "#fff",
      height: "32px",
      fontSize: "12px",
    },
    input: {
      marginLeft: "15px",
      flex: 1,
      height: "32px",
      width: "250px",
    },
    inputProps: {
      fontSize: "12px",
    },
    searchButton: {
      top: "-2px",
      padding: "10px",
      borderRadius: "2px",
      border: `1px solid #0063A3`,
      height: "32px",
      width: "32px",
    },
    clearButton: {
      top: "-2px",
      padding: "10px",
      height: "32px",
      width: "32px",
    },
  })
);

interface ProductSearchProps {
  onSearch: (searchText?: string) => void;
}
export const ProductSearch: React.FC<ProductSearchProps> = ({ onSearch }) => {
  const classes = useStyles();
  const inputRef = useRef<HTMLInputElement>(null);
  const [selected, setSelected] = React.useState<boolean>(true);
  let previousValue = "";
  const onSearchClicked = () => {
    onSearch(inputRef?.current?.value);
    previousValue = inputRef?.current?.value ?? "";
    setSelected(false);
  };
  const onClearClicked = () => {
    onSearch("");
    if(inputRef.current) {
        inputRef.current.value = "";
    }
    setSelected(true);
  };


  const handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Enter') {
          onSearchClicked();
          return;
    }
    if (previousValue !== inputRef.current?.value) {
        setSelected(true);
        }
  }
  return (
    <Box className={classes.searchBox}>
      <InputBase
        className={classes.input}
        placeholder="Search Products"
        inputProps={{ "aria-label": "Search Products", className: classes.inputProps }}
        inputRef={inputRef}
        onKeyDown={handleKeyDown} 
      />
      {selected && (
        <IconButton
          type="button"
          className={classes.searchButton}
          aria-label="search"
          onClick={onSearchClicked}
        >
          <SearchIcon color="primary" />
        </IconButton>
      )}
      {!selected && (
        <IconButton
          type="button"
          className={classes.clearButton}
          aria-label="search"
          onClick={onClearClicked}
        >
          <CloseIcon color="secondary" />
        </IconButton>
      )}
    </Box>
  );
};


export const filterProductsByText = (products: IProduct[], searchText: string) => {
  return products?.filter(product => 
    product.name?.toLowerCase().includes(searchText.toLowerCase()) || 
    product?.displayName?.toLowerCase().includes(searchText.toLowerCase()) ||
    product.shortDescription?.toLowerCase().includes(searchText.toLowerCase()) || 
    product.longDescription?.toLowerCase().includes(searchText.toLowerCase())
  );
}